import { render, staticRenderFns } from "./TrainingPlanning.vue?vue&type=template&id=40d3dd28"
import script from "./TrainingPlanning.vue?vue&type=script&lang=ts"
export * from "./TrainingPlanning.vue?vue&type=script&lang=ts"
import style0 from "./TrainingPlanning.vue?vue&type=style&index=0&id=40d3dd28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports